import { Toolbar } from '@components/App/Toolbar'
import type React from 'react'

import { clsJoin } from '@/utils'
import { StorageBadge } from '../../App/NotificationLegacy/StorageBadge'
import {
  HeaderControls,
  ProjectBadge,
  ProjectName,
  SyncStatusIndicator,
  Zoom,
} from './components'
import { ProjectMenu } from './components/ProjectMenu'
import css from './styles.module.css'
import { useHeader } from './useHeader'

export const Header: React.FC = () => {
  const {
    readOnly,
    copywriterMode,
    projectId,
    trial,
    template,
    isEmbed,
    isPrinting,
    pageContentModal,
  } = useHeader()

  const extraCn = clsJoin(
    css.project,
    (readOnly || trial || copywriterMode || template) && css.padding_right
  )

  return (
    <>
      <div className={css.header} id="project-header">
        <Toolbar extraClassName={extraCn}>
          <ProjectMenu />

          <ProjectName />

          {!isPrinting && projectId && (
            <div id="project-badge">
              <ProjectBadge
                readOnly={readOnly}
                trial={trial}
                copywriterMode={copywriterMode}
                template={template}
              />
            </div>
          )}
        </Toolbar>

        {!pageContentModal && (
          <div className={css.indicator_wrap}>
            <SyncStatusIndicator />
          </div>
        )}

        {!isEmbed && !isPrinting && <HeaderControls />}
        {isEmbed && !isPrinting && <Zoom />}
      </div>

      <StorageBadge />
    </>
  )
}
